import * as React from "react";
import { ThematicBreak } from "../../Components";
import { INotification } from "../../Managers";
import { NotificationDisplay } from "./NotificationDisplay";
import ReactDOM from "react-dom";
import "@metricell/smarttoolscore/dist/module/Styles/metricell.css";

export interface INotificationViewerProps {
    isVisible: boolean;
    notifications: INotification[];
    yPos: number;
}

export class NotificationViewer extends React.Component<INotificationViewerProps> {
    constructor(props: INotificationViewerProps) {
        super(props);

        // Create the root element for the portal.
        this._el = document.createElement(`div`);
        this._modalRoot = document.getElementById(`SmartToolsRoot`);
    }

    componentDidMount(): void {
        this._modalRoot.appendChild(this._el);
    }

    componentWillUnmount(): void {
        this._modalRoot.removeChild(this._el);
    }

    private readonly _el: HTMLDivElement;

    private readonly _modalRoot: HTMLElement;

    render(): React.ReactPortal {
        const notifications: React.ReactNode[] = [];

        for (let i = 0; i < this.props.notifications.length; i++) {
            if (!this.props.notifications[i].isRecalled) {
                notifications.push(
                    <NotificationDisplay
                        key={this.props.notifications[i].id}
                        {...this.props.notifications[i]}
                    />,
                );

                if (i < this.props.notifications.length - 1) {
                    notifications.push(
                        <ThematicBreak
                            key={`break-${this.props.notifications[i].id}`}
                        />,
                    );
                }
            }
        }
        return ReactDOM.createPortal(
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <React.Fragment>
                {this.props.isVisible && (
                    <div
                        className={`wrapper-notificationviewer`}
                        style={{
                            bottom: `${
                                window.innerHeight - this.props.yPos + 95
                            }px`,
                        }}
                    >
                        <div className={`containersizer-notificationviewer`}>
                            <div className={`scroll notificationviewer`}>
                                {/* If there are notifications then display them. */}
                                {notifications.length > 0 && notifications}
                                {/* If there are no notifications then display a message saying so. */}
                                {notifications.length === 0 && (
                                    <div
                                        className={`notificationviewer-nonotifications`}
                                    >
                                        No Notifications
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>,
            this._el,
        );
    }
}
